<template>
    <div v-if="form.errors.length > 0" class="rounded-md bg-red-50 dark:bg-red-600 p-4 mb-4" role="alert">
        <div class="flex">
            <div class="flex-shrink-0">
                <icon name="x-circle" class-icon="h-5 w-5 text-red-400 dark:text-red-100" fill="none"/>
            </div>
            <div class="ml-3">
                <slot>
                    <template v-if="form.errors[0]" v-for="error in form.errors">
                        <p class="text-sm leading-5 font-medium mb-2 text-red-500 dark:text-red-100" v-if="error.title">
                            {{ error.title }}</p>
                        <p class="text-sm leading-5 text-red-400 dark:text-red-200">{{ error.detail }}</p>
                    </template>
                    <p v-else class="text-sm leading-5 font-medium text-red-500 dark:text-red-100">
                        {{ message }}
                    </p>
                </slot>
            </div>
            <div class="ml-auto pl-3" v-if="dismissible">
                <div class="-mx-1.5 -my-1.5">
                    <button type="button" aria-label="Close" @click="dismiss"
                            class="inline-flex rounded-md p-1.5 text-red-500 dark:text-red-100 hover:bg-red-100 dark:hover:bg-red-700 focus:outline-none focus:bg-red-100 dark:focus:bg-red-700 transition">
                        <icon name="x" class-icon="h-5 w-5"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-alert',

    props: {
        form: {
            type: Object,
            required: true,
        },
        dismissible: {
            type: Boolean,
            default: true,
        },
        message: {
            type: String,
            default: function() {
                return this.$t('form.error');
            },
        },
    },

    methods: {
        dismiss() {
            if (this.dismissible) {
                this.form.clear();
            }
        },
    },
};
</script>
